module.exports = __webpack_public_path__ + "static/img/visa-photo.ea336fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mala/visa-photo.jpg
// module id = 4FMF
// module chunks = 4